module.exports = __webpack_public_path__ + "img/topBanner.8a28e2c2.png";